let call = function (
  endpoint_name,
  success,
  failure = function () {},
  url_params = {},
  data = {}
) {
  let endpoint = ""
  let apiContent = ""
  let method = null

  if (endpoint_name === "login") {
    endpoint = `/member/login`
    method = "post"
  } else if (endpoint_name === "google_login") {
    endpoint = `/member/login/google`
    method = "post"
  } else if (endpoint_name === "refresh") {
    let ts = new Date().getTime()
    endpoint = '/member/refresh?ts=' + ts
    method = "get"
  } else if (endpoint_name === "qr_update_forward") {
    endpoint = "/member/qr/update_forward"
    method = "post"
  } else if (endpoint_name === "qr_add_new") {
    endpoint = "/member/qr/add"
    method = "post"
  } else if (endpoint_name === "qr_delete") {
    endpoint = "/member/qr/delete"
    method = "post"
  } else if (endpoint_name === "brand") {
    endpoint = `/member/brand`
    method = "get"
  } else if (endpoint_name === "customers") {
    endpoint = `/member/customers/${url_params["rest_id"]}`
    method = "get"
  } else if (endpoint_name === "user_restaurants") {
    endpoint = `/member/user/restaurants`
    method = "get"
  } else if (endpoint_name === "change_restaurant") {
    endpoint = `/member/user/restaurants/change`
    method = "post"
  } else if (endpoint_name === "get_stories") {
    endpoint = `/member/stories`
    method = "get"
  } else if (endpoint_name === "grubhub") {
    endpoint = `/member/grubhub/${url_params["rest_id"]}`
    method = "get"
  } else if (endpoint_name === "add_integration") {
    endpoint = `/member/integration/add`
    method = "post"
  } else if (endpoint_name === "sales") {
    endpoint = `/member/sales/${url_params["rest_id"]}`
    method = "post"
  } else if (endpoint_name === "receipt") {
    apiContent = "blob"
    endpoint = `/member/receipt/${url_params["order_id"]}`
    method = "get"
  } else if (endpoint_name === "summaries") {
    endpoint = `/member/summaries/${url_params["rest_id"]}`
    method = "get"
  } else if (endpoint_name === "request_reset") {
    endpoint = '/member/request_reset'
    method = 'post'
  } else if (endpoint_name === "summary") {
    endpoint = `/member/summary`
    method = "post"
  } else if (endpoint_name === "payouts") {
    endpoint = `/member/payouts/${url_params["rest_id"]}`
    method = "get"
  } else if (endpoint_name === "payout-orders") {
    endpoint = `/member/payout/orders`
    method = "post"
  } else if (endpoint_name === "diners") {
    endpoint = `/member/diners`
    method = "post"
  } else if (endpoint_name === "transfers") {
    endpoint = "/member/transfers"
    method = "post"
  } else if (endpoint_name === "transfer") {
    endpoint = "/member/transfer"
    method = "post"
  } else if (endpoint_name === "adjustments") {
    endpoint = "/member/order-adjustments"
    method = "post"
  } else if (endpoint_name === "tax-rate") {
    endpoint = "/member/tax-rate"
    method = "get"
  } else if (endpoint_name === "adjust-order") {
    endpoint = "/member/adjust-order"
    method = "post"
  } else if (endpoint_name === "transactions") {
    endpoint = "/member/transactions/orders"
    method = "post"
  } else if (endpoint_name === "menu") {
    endpoint = `/api/rest/menu/${url_params.subdomain}`
    method = "get"
  } else if (endpoint_name === "menu-modifiers") {
    endpoint = `/api/rest/menu-modifiers/${url_params.subdomain}`
    method = "get"
  } else if (endpoint_name === "blackout") {
    endpoint = `/api/rest/menu-item-blackout/${url_params.subdomain}`
    method = "get"
  } else if (endpoint_name === "blackout-item") {
    endpoint = "/member/menu/blackout-item/item"
    method = "post"
  } else if (endpoint_name === "reactivate-item") {
    endpoint = `/member/menu/activate-item/item`
    method = "post"
  } else if (endpoint_name === "activate-bulk") {
    endpoint = "/member/menu/activate-bulk"
    method = "post"
  } else if (endpoint_name === "reconcilliations") {
    endpoint = `/member/reconcilliations`
    method = "post"
  } else if (endpoint_name === "reconcilliation") {
    endpoint = `/member/reconcilliation`
    method = "post"
  } else if (endpoint_name === "hours") {
    endpoint = "/member/hours"
    method = "post"
  } else if (endpoint_name === "save-hours") {
    endpoint = "/member/save-hours"
    method = "post"
  } else if (endpoint_name === "is-closed-early") {
    endpoint = "/member/is-closed-early"
    method = "post"
  } else if (endpoint_name === "close-early") {
    endpoint = "/member/close-early"
    method = "post"
  } else if (endpoint_name === "undo-close-early") {
    endpoint = "/member/undo-close-early"
    method = "post"
  } else if (endpoint_name === "special-hours") {
    endpoint = "/member/special-hours"
    method = "post"
  } else if (endpoint_name === "special-hours-new") {
    endpoint = "/member/special-hours-new"
    method = "post"
  } else if (endpoint_name === "special-hours-delete") {
    endpoint = "/member/special-hours-delete"
    method = "post"
  } else if (endpoint_name === "default-prep-time-get") {
    endpoint = "/member/default-prep-time-get"
    method = "post"
  } else if (endpoint_name === "temp-default-prep-time-set") {
    endpoint = "/member/temp-default-prep-time-set"
    method = "post"
  } else if (endpoint_name === "default-prep-time-set") {
    endpoint = "/member/default-prep-time-set"
    method = "post"
  } else if (endpoint_name === "users") {
    endpoint = "/member/users"
    method = "post"
  } else if (endpoint_name === "save-user") {
    endpoint = "/member/save-user"
    method = "post"
  } else if (endpoint_name === "save-info") {
    endpoint = "/member/save-info"
    method = "post"
  } else if (endpoint_name === "save-color") {
    endpoint = "/member/save-color"
    method = "post"
  } else if (endpoint_name === 'tablet-api-key'){
    endpoint ='/member/tablet-api-code'
    method='post'
  } else {
    alert(endpoint_name + " is not a valid endpoint")
  }

  let url = `${process.env.REACT_APP_FOODCOIN_API_LOCATION}${endpoint}`
  let headers = null
  let api_key = localStorage.getItem("api_key")
  if (method === "post") {
    headers = {
      "X-HNGR-API-KEY": api_key,
      "Content-Type": "application/json",
      "Clickstream-Session-Id": window.CLICKSTREAM_SESSION_ID,
      token_id: window.TOKEN_ID,
      "App-Version": window.APP_VERSION,
    }
    fetch(url, { method: "post", headers: headers, body: JSON.stringify(data) })
      .then((res) => {
        if (res.ok) {
          res.json().then((json) => success(json))
        } else {
          res.json().then((json) => failure(json))
        }
      })
      .catch((err) => {
        console.log(err)
        if (failure) {
          failure(err)
        }
      })
  }

  if (method === "patch") {
    headers = {
      "X-HNGR-API-KEY": api_key,
      "Content-Type": "application/json",
      "Clickstream-Session-Id": window.CLICKSTREAM_SESSION_ID,
      token_id: window.TOKEN_ID,
      "App-Version": window.APP_VERSION,
    }
    fetch(url, {
      method: "patch",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (res.ok) {
          res.json().then((json) => success(json))
        } else {
          res.json().then((json) => failure(json))
        }
      })
      .catch((err) => {
        console.log(err)
        if (failure) {
          failure(err)
        }
      })
  }

  if (method === "delete") {
    headers = {
      "X-HNGR-API-KEY": api_key,
      "Content-Type": "application/json",
      "Clickstream-Session-Id": window.CLICKSTREAM_SESSION_ID,
      token_id: window.TOKEN_ID,
      "App-Version": window.APP_VERSION,
    }
    fetch(url, { method: "delete", headers: headers })
      .then((res) => {
        if (res.ok) {
          res.json().then((json) => success(json))
        } else {
          res.json().then((json) => failure(json))
        }
      })
      .catch((err) => {
        console.log(err)
        if (failure) {
          failure(err)
        }
      })
  }

  if (method === "get") {
    headers = {
      "X-HNGR-API-KEY": api_key,
      "Clickstream-Session-Id": window.CLICKSTREAM_SESSION_ID,
    }

    if (apiContent === "blob") {
      fetch(url, { method: "get", headers: headers })
        .then((res) => {
          if (res.ok) {
            res.blob().then((blob) => success(blob))
          } else {
            res.blob().then((blob) => failure(blob))
          }
        })
        .catch((err) => {
          console.log(err)
          if (failure) {
            failure(err)
          }
        })
    } else {
      fetch(url, { headers: headers, method: "get" })
        .then((res) => {
          if (res.ok) {
            res.json().then((json) => success(json))
          } else {
            res.json().then((json) => failure(json))
          }
        })
        .catch((err) => {
          console.log(err)
          if (failure) {
            failure(err)
          }
        })
    }
  }
}

module.exports = {
  call: call,
}
